<ng-container *ngIf="activatablePackages$ | async as activatablePackages; else loadingTableItems">
  <ng-container>
    <div class="search-container">
      <div class="search-child">
        <va-search-box
          [highlightWhenSelected]="true"
          [disabled]="false"
          (update)="onPackageSearchTermChanged($event)"
          (submit)="onPackageSearchTermChanged($event)"
        ></va-search-box>
      </div>
      <div class="search-child toggle-restricted" *ngIf="packagesHasRestrictions$ | async">
        <a (click)="toggleRestrictedPackages()">
          {{
            (showingRestrictedPackages$ | async)
              ? ('ACTIVATION.SELECTION_PAGE.PACKAGE_ACTIVATION_TABLE.HIDE_UNAVAILABLE' | translate)
              : ('ACTIVATION.SELECTION_PAGE.PACKAGE_ACTIVATION_TABLE.SHOW_UNAVAILABLE' | translate)
          }}
        </a>
      </div>
    </div>
    <div class="table-body">
      <ng-container
        *ngIf="{
          selectedItems: selectedItems$ | async,
          showingRestrictedPackages: showingRestrictedPackages$ | async,
          hidePricing: hidePricing$ | async
        } as packageActivationData"
      >
        <app-package-activation-table-component
          *ngIf="activatablePackages.length > 0; else noPackages"
          [activatablePackages]="activatablePackages"
          [selectedItems]="packageActivationData.selectedItems"
          [showRestricted]="packageActivationData.showingRestrictedPackages"
          [hidePricing]="packageActivationData.hidePricing"
          (sortChanged)="onPackageSortOrderChanged($event)"
          (packageCheckboxClicked)="onPackageCheckboxClicked($event)"
        ></app-package-activation-table-component>
      </ng-container>
    </div>
    <div class="table-footer">
      <mat-paginator
        [length]="totalPackages$ | async"
        [pageSize]="25"
        [pageSizeOptions]="pageOptions"
        (page)="onPackagePage($event)"
      ></mat-paginator>
    </div>
  </ng-container>
</ng-container>

<ng-template #loadingTableItems>
  <store-list-stencil [numRows]="8"></store-list-stencil>
</ng-template>
<ng-template #noPackages>
  <p class="no-packages-text">
    {{ 'ACTIVATION.SELECTION_PAGE.PACKAGE_ACTIVATION_TABLE.NO_PACKAGES_MATCH_SEARCH' | translate }}
    <a routerLink="/marketplace/manage-store/recommended">
      {{ 'ACTIVATION.SELECTION_PAGE.PACKAGE_ACTIVATION_TABLE.VIEW_RECOMMENDED_PACKAGES' | translate }}
    </a>
  </p>
</ng-template>
